import { FormHelperText, Grid, Typography } from '@mui/material'
import React from 'react'
import { get, useFormContext } from 'react-hook-form'
import { regionsSelectItems } from '../../utils/geoData/geoData'
import { ControlledCheckbox } from '../ControlledCheckbox'

export const RegionCheckboxes = ({ initialValues = {} }) => {
  const { formState, watch } = useFormContext()
  const error = get(formState.errors, 'region')
  const regionList = watch('region', initialValues)

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography variant='body1' style={{ paddingBottom: 8 }}>
            Region
          </Typography>
        </Grid>
        {regionsSelectItems.map(region => (
          <Grid item xs={12} sm={6} key={region.code}>
            <ControlledCheckbox
              name={`region.${region.code}`}
              label={region.label}
              checked={regionList[region.code] ?? false}
            />
          </Grid>
        ))}
      </Grid>
      {error?.message !== undefined && (
        <FormHelperText
          id={`error-helper-text-region`}
          error
          style={{ textAlign: 'left', paddingRight: 8 }}
        >
          {error?.message}
        </FormHelperText>
      )}
    </>
  )
}
